import React from 'react';
import {Prompt} from 'react-router-dom';

import http from 'api/http';
import {oilAPI} from 'api/requests';

import Header from './Header';
import BrandTypeSection from './BrandTypeSection';
import NotesSection from './Notes';
import GeneralInformation from './GeneralInformation';
import NotificationManager from 'dom-managers/notification';
import ApplicationActions from 'Components/ApplicationActions';
import ContactDetails from './ContactDetails'
import Modal from 'Components/Modal';
import Button, {buttonColor, buttonType} from 'Components/Button';

export default class DetailsApplication extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputErrors: {},
      isModalOpen: false,
    };

    const applicationData = props.applicationData;

    if (applicationData) {
      this.state.name = applicationData.name;
      this.state.description = applicationData.description;
      this.state.manufacturerAddress = applicationData.manufacturerAddress;
      this.state.notes = applicationData.notes;
    }

    this.requiredFields = ['manufacturerAddress', 'name'];
    this.someDataWasInputted = false;
  }

  componentDidUpdate() {
    const { applicationData } = this.props;

    if (applicationData && !this.state.name)
      this.setState({
        name: applicationData.name,
        description: applicationData.description,
        manufacturerAddress: applicationData.manufacturerAddress,
        notes: applicationData.notes,
      });
  }

  handleInputChange = field => (value, error) => {
    const { inputErrors } = this.state;
    if (!error || error.ops) {
      delete inputErrors[field];
      this.someDataWasInputted = true;
      this.setState({ [field]: value, inputErrors });
    }
  };

  handleSelect = fieldName => input => {
    const { inputErrors } = this.state;

    delete inputErrors[fieldName];
    this.someDataWasInputted = true;

    this.setState({ [fieldName]: input.value, inputErrors });
  };

  validateForm = () => {
    const { inputErrors } = this.state;
    let newInputErrors = inputErrors;

    const isEmptyArray = object => {
      return object.length !== undefined && typeof object === 'object' && !object.length;
    };

    const isEmptyString = object => {
      return !object.length && typeof object === 'string' && !object.length;
    };

    const isEmptyObject = object => {
      return object.length === undefined && typeof object === 'object' && !Object.keys(object).length;
    };

    this.requiredFields.forEach(fieldName => {
      if (
        isEmptyString(this.state[fieldName]) ||
        isEmptyArray(this.state[fieldName]) ||
        isEmptyObject(this.state[fieldName])
      )
        newInputErrors[fieldName] = true;
    });

    return new Promise((resolve, reject) => {
      this.setState({ inputErrors: newInputErrors }, () => {
        if (Object.keys(this.state.inputErrors).length) reject();
        else resolve();
      });
    });
  };

  updateBrand = () => {
    const { name, manufacturerAddress, description, notes } = this.state;
    const { user, match } = this.props;

    this.validateForm().then(() => {
      http
        .post(oilAPI.updateBrand, {
          id: match.params.applicationId,
          name,
          manufacturerAddress: manufacturerAddress,
          description,
          notes,
        })
        .then(() => {
          NotificationManager.success(1, 'Brand details successfully updated');
          this.someDataWasInputted = false;
          user.goToList();
        });
    });
  };

  handleBackButtonClick = () => {
    const { user } = this.props;
    user.goToList();
  };

  _openModal = () => {
    this.setState({ isModalOpen: true });
  };

  _closeModal = () => {
    this.setState({ isModalOpen: false, requestInProcess: false });
  };

  blockUnconfirmedTransition = location => {
    const { user } = this.props;

    if (this.someDataWasInputted) {
      this.modalBody = 'You have unsaved data. Are you sure you want to exit application without saving?';
      this.modalConfirmAction = () => {
        this.someDataWasInputted = false;
        this._closeModal();
        user.goTo(location);
      };
      this._openModal();
      return false;
    }
    return true;
  };

  render() {
    const { inputErrors, name, description, manufacturerAddress, notes, isModalOpen } = this.state;
    const { user, match, applicationData, manufacturerAddresses } = this.props;

    const { applicationId } = match.params;

    if (!applicationData) {
      return (
        <section className='scene__scene-wrapper'>
          <section className='scene__content-wrapper detailsScene__content-wrapper'>
            <Header handleBackButtonClick={this.handleBackButtonClick} loadInProgress={true} />
            <div className='ect-spinner _width_pc_100 _height_120'>
              <div className='ect-spinner__image' />
            </div>
          </section>
        </section>
      );
    } else {
      const {
        applicationStatus,
        number,
        year,
        isPaid,
        submissionDate,
        approvalDate,
        formulaBaseOilNumber,
        formulaEngineType,
        submittedBy,
      } = applicationData;

      return (
        <React.Fragment>
          <section className='scene__scene-wrapper'>
            <section
              className={`scene__content-wrapper detailsScene__content-wrapper ${applicationStatus.toLowerCase()}`}
            >
              <Header
                applicationStatus={applicationStatus}
                applicationId={applicationId}
                handleBackButtonClick={this.handleBackButtonClick}
                loadInProgress={!applicationData}
              />
              <BrandTypeSection number={number} year={year} isPaid={isPaid} />
              <GeneralInformation
                submissionDate={submissionDate}
                approvalDate={approvalDate}
                name={name}
                formulaBaseOilNumber={formulaBaseOilNumber}
                formulaEngineType={formulaEngineType}
                description={description}
                inputErrors={inputErrors}
                handleInputChange={this.handleInputChange}
              />
              <NotesSection user={user} notes={notes} handleInputChange={this.handleInputChange} />
              <ContactDetails
                submittedBy={submittedBy}
                manufacturerAddress={manufacturerAddress}
                handleSelect={this.handleSelect}
                inputErrors={inputErrors}
                user={user}
                applicationStatus={applicationStatus}
                manufacturerAddresses={manufacturerAddresses}
              />
              <ApplicationActions
                saveButtonLabel={'Save'}
                saveButtonAction={this.updateBrand}
                backButtonLabel='Cancel'
                backButtonAction={this.handleBackButtonClick}
              />
            </section>
          </section>
          <Modal isOpen={isModalOpen}>
            <header className='ect-modal-header'>Confirmation</header>
            <div className='ect-modal-body'>{this.modalBody}</div>
            <footer className='ect-modal-footer'>
              <Button
                label='No'
                type={buttonType.secondary}
                color={buttonColor.gray}
                buttonClassName='_height_40 _width_160'
                onClick={this._closeModal}
              />
              <Button label='Yes' buttonClassName='_height_40 _width_160' onClick={this.modalConfirmAction} />
            </footer>
          </Modal>
          <Prompt message={this.blockUnconfirmedTransition} />
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/Edit/index.jsx